import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatChipGrid, MatChipInput, MatChipInputEvent, MatChipRemove, MatChipRow } from '@angular/material/chips';
import { filter, Subscription, take, tap } from 'rxjs';
import { COMMA, ENTER, SEMICOLON, SPACE, TAB } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-text-array-filter',
  standalone: true,
  templateUrl: './text-array-filter.component.html',
  imports: [
    MatFormField,
    MatChipGrid,
    ReactiveFormsModule,
    MatChipRow,
    MatChipRemove,
    MatChipInput,
    MatLabel,
    MatError
  ],
  styleUrl: './text-array-filter.component.scss'
})
export class TextArrayFilterComponent implements OnChanges, OnDestroy {
  @Input() paramsGroup!: FormGroup;
  values = new Set<string>();
  separatorKeysCodes = [ENTER, COMMA, SPACE, SEMICOLON, TAB];

  private subscription = new Subscription();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['paramsGroup']) {
      this.subscription.add(
        this.paramsGroup.valueChanges
          .pipe(
            take(1),
            filter(val => Boolean(val)),
            tap(({ value }: { value: string[] }) => {
              this.values.clear();
              value.forEach(val => this.values.add(val));
            })
          )
          .subscribe()
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  add(event: MatChipInputEvent) {
    const value = (event.value || '').trim();
    if (value) {
      this.values.add(value);
    }
    event.chipInput!.clear();
  }

  remove(value: string) {
    this.values.delete(value);
  }
}
